import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const titlePrefix = "Cosmic Guard";
const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "index",
    meta: {
      title: "DDoS Protection Solutions by " + titlePrefix,
    },
    component: () => import("../pages/Index.vue"),
  },
  {
    path: "/gaming",
    name: "gaming",
    meta: {
      title: "Game Server DDoS Protection - " + titlePrefix,
      metaTags: [
        {
          name: "description",
          content:
            "DDoS Protection for any Linux or Windows game server within minutes. Eliminate downtime and keep your players happy.",
        },
        {
          property: "og:description",
          content:
            "DDoS Protection for any Linux or Windows game server within minutes. Eliminate downtime and keep your players happy.",
        },
      ],
    },
    component: () => import("../pages/Gaming.vue"),
  },
  {
    path: "/servers",
    name: "servers",
    meta: {
      title: "Remote DDoS Protection for Servers - " + titlePrefix,
      metaTags: [
        {
          name: "description",
          content:
            "DDoS Protection for any Linux or Windows server in minutes. Eliminate downtime and keep your servers online.",
        },
        {
          property: "og:description",
          content:
            "DDoS Protection for any Linux or Windows server in minutes. Eliminate downtime and keep your servers online.",
        },
      ],
    },
    component: () => import("../pages/Servers.vue"),
  },
  {
    path: "/hosts",
    name: "hosts",
    meta: {
      title: "Hosting Service Provider DDoS Protection - " + titlePrefix,
      metaTags: [
        {
          name: "description",
          content:
            "Do you run a hosting service? You need expert level DDoS Protection. Get started now and keep your customers online within minutes.",
        },
        {
          property: "og:description",
          content:
            "Do you run a hosting service? You need expert level DDoS Protection. Get started now and keep your customers online within minutes.",
        },
      ],
    },
    component: () => import("../pages/Hosts.vue"),
  },
  {
    path: "/enterprise",
    name: "enterprise",
    meta: {
      title: "Enterprise DDoS Protection - " + titlePrefix,
      metaTags: [
        {
          name: "description",
          content:
            "Over five million DDoS attacks are launched yearly. Protecting your business from cybercriminals is key to your success. Let us show you how Cosmic Guard can help.",
        },
        {
          property: "og:description",
          content:
            "Over five million DDoS attacks are launched yearly. Protecting your business from cybercriminals is key to your success. Let us show you how Cosmic Guard can help.",
        },
      ],
    },
    component: () => import("../pages/Enterprise.vue"),
  },
  { path: "/category/gaming", redirect: "/gaming" },
  { path: "/category/servers", redirect: "/servers" },
  { path: "/category/hosts", redirect: "/hosts" },
  { path: "/category/enterprise", redirect: "/enterprise" },
  {
    path: "/signup",
    name: "signup",
    meta: {
      title: "Sign Up - " + titlePrefix,
    },
    component: () => import("../pages/Signup.vue"),
  },
  {
    path: "/signup/:id",
    name: "signup-confirm",
    meta: {
      title: "Sign Up - " + titlePrefix,
    },
    component: () => import("../pages/SignupConfirm.vue"),
  },
  {
    path: "/promo/:id",
    name: "signup-promo",
    meta: {
      title: "Sign Up - " + titlePrefix,
    },
    component: () => import("../pages/Signup.vue"),
  },
  {
    path: "/emergency",
    name: "emergency",
    meta: {
      title: "Emergency DDoS Protection Solutions - " + titlePrefix,
    },
    component: () => import("../pages/Emergency.vue"),
  },
  {
    path: "*",
    name: "error404",
    redirect: { name: "index" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes,
});

router.beforeEach((to, _, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }
  next();
});

export default router;
